import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showShareDataset } from '../actions';

const ShareDatasetAction = ({
  category,
  code,
  readErrors,
  share,
  secureOnly,
  disabled,
  name,
}) => (
  <RibbonMenu
    name="share"
    icon={secureOnly ? 'shield' : 'share alternate'}
    message={secureOnly ? 'actions.security' : 'actions.share'}
    onClick={() => share(category, code, name)}
    className="aridhia-share-dataset-action"
    disabled={firstError(readErrors) !== null || disabled}
  />
);

const mapStateToProps = ({
  catalogues: { catalogues },
}, { category, code }) => {
  const catalogue = findResult(catalogues, category, code);

  return {
    readErrors: catalogue ? catalogue.readErrors : [],
    name: catalogue ? catalogue.catalogue.title : null,
  };
};

const mapDispatchToProps = {
  share: showShareDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareDatasetAction);
